import React from "react";
import { Button, Modal } from "@mantine/core";

export default function ProceedModal(props) {
  return (
    <Modal opened={props.open} size="tiny">
      <Modal.Title>{props.header}</Modal.Title>
      {props.children && <Modal.Body>{props.children}</Modal.Body>}
      <Modal.Footer>
        <Button variant="outline" onClick={props.onNoClick}>
          No, I'll come back later
        </Button>
        <Button onClick={props.onYesClick}>Yes! Let's Go!</Button>
      </Modal.Footer>
    </Modal>
  );
}

ProceedModal.defaultProps = {
  header: "Are you ready?",
  open: false,
};
